import { Component, OnInit } from '@angular/core';
import { QuotationModule, QuotationDetail, ModuleProgramme } from '../services/domain.service';
import { QuotationsService } from '../services/quotations.service';
import { GlobalsService } from '../services/globals.service';
import { Router } from '@angular/router';
import { StudentType } from '../services/enums.service';
import { DataService } from '../services/data.service';
import { MatTableDataSource } from '@angular/material';
import { Observable, forkJoin } from 'rxjs';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.less']
})
export class ModulesComponent implements OnInit {
  degreeFullName: string = "";
  programmeHasModules = true;

//This is the seciton from confirmation screen
quotationDetail: QuotationDetail = { studentType: StudentType.local, academicYear: 0, degreeTypeId: "",    degreeTypeName: "", 
    gradTypeId: "", gradTypeName: "", studyTypeId: "", studyTypeName: "", facultyId: "", facultyName: "", programmeId: 0, 
    programmeName: "", streamId: "", streamName: "", yearLevelId: 0, yearLevelName: "", quotationsModules: [], programmeDuration: 0, chargeByModule: true, programmeCost: 0,
    includeRes: false, generateQuotation: false, generateProforma: false, residence: undefined, personalInfo: undefined, proformaInfo: undefined };
moduleProgramme: ModuleProgramme = undefined;
quotationModule: Array<QuotationModule> = [];
coreModules: Array<QuotationModule> = [];
electiveModules: Array<QuotationModule> = [];

coreRulesKeyCount: number = 0;
selectedCoreRulesKey: number = 0;

maxCredits: number = 0;
subTotalItems: Array<SubTotalItem> = [];
subTotalItem: SubTotalItem = { description: 'Total tuition fees', amount: 0, credits: 0 };

coreDataSource: MatTableDataSource<QuotationModule>;
electiveDataSource: MatTableDataSource<QuotationModule>;
spans = [];

chargeByModule: boolean = true;
programmeCost: number = 0;

displayedResColumns: string[] = ['resSelect', 'resCode', 'resName', 'roomTypeName', 'priceRange'];
displayedModuleColumns: string[] = ['modChecked', 'modSubChecked','moduleCode', 'moduleName', 'moduleCost', 'moduleCredits'];
displayedSubTotalColumn: string[] = ['description', 'amount', 'credits'];

constructor(private service: QuotationsService,
  private globals: GlobalsService,
  private router: Router,
  private data: DataService,
  private notifier: SnotifyService) { }

  ngOnInit() {
    this.data.changePage("modules");
    this.loadModuleDetails();
  }

  async loadModuleDetails(){
    //This forces to display spinner
    await this.delay(100); 

    this.data.isLoading(true);
    
    if(this.globals.quotationDetail) {
      this.quotationDetail = this.globals.quotationDetail;

      this.degreeFullName = this.quotationDetail.programmeName;
      if(this.degreeFullName != "" && this.quotationDetail.streamName && this.quotationDetail.streamName != "") {
        this.degreeFullName = this.degreeFullName.concat(" (", this.quotationDetail.streamName, ")");
      }

      this.getModuleDetails().subscribe(response => {
        this.moduleProgramme = response [0] as ModuleProgramme;

        if(this.moduleProgramme) {
          this.maxCredits = this.moduleProgramme.maxYearLevelCredits ? this.moduleProgramme.maxYearLevelCredits : 0;
          
          //Validate charge type
          if((this.moduleProgramme.chargeType == 'P' && this.moduleProgramme.yearLevel == 1) ||
          this.moduleProgramme.chargeType == 'E' || this.moduleProgramme.chargeType == 'N') {
            this.chargeByModule = false;
            if(this.moduleProgramme.chargeType != 'N'){
              this.programmeCost = this.quotationDetail.studentType == StudentType.international ? this.moduleProgramme.costInt : this.moduleProgramme.costLocal;
            }
          }

          this.quotationDetail.chargeByModule = this.chargeByModule;
          this.quotationDetail.programmeCost = this.programmeCost;

          if(this.moduleProgramme && this.moduleProgramme.modules) {
            this.moduleProgramme.modules.forEach( m => {
              if(m.ruleType == 'C') {
                this.coreModules.push({ modChecked: false, modSubChecked: false, rulesKey: m.rulesKey, sequence: m.sequence, connector: m.connector, 
                  moduleCode: m.moduleCode, moduleName: m.moduleName, moduleCost: this.quotationDetail.studentType == StudentType.international ? m.costInt : m.costLocal, 
                  moduleCredits: m.credits, electiveGroup1: m.electiveGroup1, electiveGroup2: m.electiveGroup2, compulsorySubGroup: m.compulsorySubGroup, isCore: true, isDisabled: false, isSubDisabled: false});
              } else if(m.ruleType == 'E') {
                this.electiveModules.push({ modChecked: false, modSubChecked: false, rulesKey: m.rulesKey, sequence: m.sequence, connector: m.connector, 
                  moduleCode: m.moduleCode, moduleName: m.moduleName, moduleCost: this.quotationDetail.studentType == StudentType.international ? m.costInt : m.costLocal, 
                  moduleCredits: m.credits, electiveGroup1: m.electiveGroup1, electiveGroup2: m.electiveGroup2, compulsorySubGroup: m.compulsorySubGroup, isCore: false, isDisabled: false, isSubDisabled: false});
              }
            });
          }
          
          //Reload previously selected modules, if any
          if(this.quotationDetail.quotationsModules) {
            let selectedCoreRulesKey: number = 0;
            let selectedElectGroups: Array<PrevSelectedElectGroups> = [];
            let selectedCoreGroups: Array<PrevSelectedElectGroups> = [];
            this.quotationDetail.quotationsModules.forEach(function(mod) {
              if(mod.isCore){
                selectedCoreRulesKey = mod.rulesKey;
                var prevSelection: PrevSelectedElectGroups = selectedElectGroups.find(s => s.electGroup1 == mod.electiveGroup1 && s.electGroup2 == mod.electiveGroup2)
                if(!prevSelection){
                  selectedCoreGroups.push({electGroup1: mod.electiveGroup1, electGroup2: mod.electiveGroup2});
                }
              } else {
                var prevSelection: PrevSelectedElectGroups = selectedElectGroups.find(s => s.electGroup1 == mod.electiveGroup1 && s.electGroup2 == mod.electiveGroup2)
                if(!prevSelection) {
                  selectedElectGroups.push({electGroup1: mod.electiveGroup1, electGroup2: mod.electiveGroup2});
                }
              }
            });
  
            if(selectedCoreRulesKey != 0) {
              this.updateTotalsCore(true, selectedCoreRulesKey);
              selectedCoreGroups.forEach(g => {
                this.updateTotalsSubCore(true, g.electGroup1, g.electGroup2);
              });
            }
  
            var i: number;
            for(i = 0; i < selectedElectGroups.length; i++){
              this.updateTotalElect(true, selectedElectGroups[i].electGroup1, selectedElectGroups[i].electGroup2);
            }
          }
  
          this.coreDataSource = new MatTableDataSource([]);
          this.electiveDataSource = new MatTableDataSource([]);
  
          this.coreDataSource.data = this.coreModules;
          this.electiveDataSource.data = this.electiveModules;
  
          this.coreRulesKeyCount = this.countUniqueRulesKey(this.coreModules);
          if(this.coreRulesKeyCount == 1) {
            this.coreModules.forEach(m => {
              m.modChecked = true
              if(m.compulsorySubGroup == true){
                m.modSubChecked = true;
              }
            });
            this.updateTotals();
          }
          
          this.cacheCoreSpan('coreRulesKey', d => d.rulesKey);
          this.cacheCoreSpan('coreGroup2', d => d.rulesKey + d.electiveGroup2);
          this.cacheElectSpan('electiveGroup1', d => d.electiveGroup1);
          this.cacheElectSpan('electiveGroup2', d => d.electiveGroup1 + d.electiveGroup2)
        }
      }, error => {
        this.data.isLoading(false);
        this.programmeHasModules = false;
        console.log('Error on getModuleDetails(): ', error);
        this.showError('getModuleDetails');
      }, () => {
        this.data.isLoading(false);
        if(this.coreModules.length == 0 && this.electiveModules.length == 0){
          this.programmeHasModules = false
    
          this.notifier.warning('Programme not available for Online Quotations or Pro-forma Invoices.  Please select another Programme.', {
            timeout: 0,
            position: SnotifyPosition.centerCenter,
            closeOnClick: false,
            buttons: [
              {text: 'Ok'}
            ]
          });
        }
      });
    } else {
      this.programmeHasModules = false;
      this.data.isLoading(false);
    }
  }

  private delay(ms: number)
  {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getModuleDetails(): Observable<any>{

    console.log(this.quotationDetail.academicYear)
    console.log(this.quotationDetail.programmeId)
    console.log(this.quotationDetail.streamId)
    console.log(this.quotationDetail.studyTypeId)
    console.log(this.quotationDetail.yearLevelId)

    let moduleDetails = this.service.getModuleProgramme(this.quotationDetail.academicYear, this.quotationDetail.programmeId, 
      this.quotationDetail.streamId, this.quotationDetail.studyTypeId, this.quotationDetail.yearLevelId);
    
      return forkJoin(moduleDetails);
  }

  countUniqueRulesKey(modules: Array<QuotationModule>): number {
    let uniqueCoreRulesKey: Array<number> = [];
    modules.forEach(function(module) {
      if(uniqueCoreRulesKey.indexOf(module.rulesKey) == -1) {
        uniqueCoreRulesKey.push(module.rulesKey);
      }
    });

    return uniqueCoreRulesKey.length;
  }

  updateTotalsCore(checked: boolean, rulesKey: number) {
    if(checked){
      this.selectedCoreRulesKey = rulesKey;
    } else {
      this.selectedCoreRulesKey = 0;
    }

    //First unselect all previously selected modules
    this.coreModules.forEach(function(module) {
      module.modChecked = false;
      module.modSubChecked = false;
      module.isSubDisabled = false;
    })

    //Then select all modules for the current rulesKey
    this.coreModules.forEach(function(module) {
      if(module.rulesKey == rulesKey) {
        module.modChecked = checked;
        if(checked == false){
          module.modSubChecked = false; //Uncheck everything if main checkbox is unchecked
        }
        else if(module.compulsorySubGroup == true) {
          module.modSubChecked = checked; //Else only check compulsory sub groups if main checknox is checked
        }
      }

      if(module.modChecked == true){
        if(module.rulesKey == rulesKey){
          module.isSubDisabled = false;
        } else {
          module.isSubDisabled = true;
        }
      }
    });

    this.updateTotals();
  }

  updateTotalsSubCore(checked: boolean, rulesKey: number, subGroup: number){
    this.coreModules.forEach(mod => {
      if(mod.rulesKey == rulesKey && mod.electiveGroup2 == subGroup) {
        if(mod.electiveGroup2 == subGroup){
          mod.modSubChecked = checked;
        }
      }
      else if(mod.rulesKey == rulesKey && !mod.compulsorySubGroup && mod.electiveGroup2 != subGroup && checked){
        mod.modSubChecked = false;
      }
    });

    this.updateTotals();
  }

  updateTotalElect(checked: boolean, electiveGroup1: number, electiveGroup2: number) {
    this.electiveModules.forEach(function(mod) {
      if(mod.electiveGroup1 == electiveGroup1 && mod.electiveGroup2 == electiveGroup2) {
        mod.modSubChecked = checked;
      }
      mod.isDisabled = false;
      mod.isSubDisabled = false;
    });

    //Disable groups that have overlapping modules
    var selectedGroups: Array<PrevSelectedElectGroups> = [];
    var selectedModules: Array<string> = [];
    //Get selected modules and their respective elective groups
    this.electiveModules.forEach(function(mod){
      if(mod.modSubChecked){
        selectedModules.push(mod.moduleCode);
        var prevSelection: PrevSelectedElectGroups = selectedGroups.find(s => s.electGroup1 == mod.electiveGroup1 && s.electGroup2 == mod.electiveGroup2)
        if(!prevSelection) {
          selectedGroups.push({electGroup1: mod.electiveGroup1, electGroup2: mod.electiveGroup2});
        }
      }
    });

    //Get a list of groups to be disabled (with overlaping modules)
    let groupsToDisable: Array<GroupsToDisable> = []
    this.electiveModules.forEach(function(mod){
      var isGroupSelected = selectedGroups.find(g => g.electGroup1 == mod.electiveGroup1 && g.electGroup2 == mod.electiveGroup2)
      if(selectedModules.indexOf(mod.moduleCode) > -1 && !isGroupSelected){
        var groupToDisable = groupsToDisable.find(g => g.electGroup1 == mod.electiveGroup1 && g.electGroup2 == mod.electiveGroup2)
        if(!groupToDisable){
          groupsToDisable.push({electGroup1: mod.electiveGroup1, electGroup2: mod.electiveGroup2});;
        }
      }
    });

    //Disable the elective groups that have overlaping modules
    this.electiveModules.forEach(function(mod){
      var isGroupToDisable = groupsToDisable.find(g => g.electGroup1 == mod.electiveGroup1 && g.electGroup2 == mod.electiveGroup2);
      if(isGroupToDisable) {
        mod.isDisabled = true;
        mod.isSubDisabled = true;
      }
    });
    
    this.updateTotals();
  }

  updateTotals(){
    let moduleFees: number = 0;
    let moduleCredits: number = 0;

    this.coreModules.forEach(m => {
      if(m.modSubChecked == true){
      moduleFees += m.moduleCost;
      moduleCredits += m.moduleCredits;
      };
    });

    this.electiveModules.forEach(m => {
      if(m.modSubChecked == true){
      moduleFees += m.moduleCost;
      moduleCredits += m.moduleCredits;
      };
    });

    if(this.chargeByModule == false) {
      moduleFees = this.programmeCost;
    }

    this.subTotalItem = { description: 'Total tuition fees', amount: moduleFees, credits: moduleCredits };
  };

  cacheCoreSpan(key, accessor) {
    for (let i = 0; i < this.coreModules.length;) {
      let currentValue = accessor(this.coreModules[i]);
      let count = 1;

      // Iterate through the remaining rows to see how many match
      // the current value as retrieved through the accessor.
      for (let j = i + 1; j < this.coreModules.length; j++) {        
        if (currentValue != accessor(this.coreModules[j])) {
          break;
        }

        count++;
      } 

      if (!this.spans[i]) {
        this.spans[i] = {};
      }

      // Store the number of similar values that were found (the span)
      // and skip i to the next unique row.
      this.spans[i][key] = count;
      i += count;
    }
  }

  cacheElectSpan(key, accessor) {
    for (let i = 0; i < this.electiveModules.length;) {
      let currentValue = accessor(this.electiveModules[i]);
      let count = 1;

      // Iterate through the remaining rows to see how many match
      // the current value as retrieved through the accessor.
      for (let j = i + 1; j < this.electiveModules.length; j++) {        
        if (currentValue != accessor(this.electiveModules[j])) {
          break;
        }

        count++;
      } 

      if (!this.spans[i]) {
        this.spans[i] = {};
      }

      // Store the number of similar values that were found (the span)
      // and skip i to the next unique row.
      this.spans[i][key] = count;
      i += count;
    }
  }

  getRowSpan(col, index) {
    return this.spans[index] && this.spans[index][col];
  }

  proceed() {
    if(this.coreModules.length > 0) {
      //Validate that one group of core modules is selected
      let coreModule = this.coreModules.find(m => m.modChecked && m.isCore);
      if(!coreModule){
        this.notifier.warning('You have to select at least one group of modules in the Compulsory Modules section.', {
          timeout: 0,
          position: SnotifyPosition.centerCenter,
          closeOnClick: false,
          buttons: [
            {text: 'Ok'}
          ]
        });
        return;
      }
    }

    var maxCreditsLimit = this.maxCredits * 1.25;
    if(maxCreditsLimit > 0 && this.subTotalItem.credits > maxCreditsLimit){
      this.notifier.warning('Selected credits far exceed the maximum allowed. maximum allowed is ' + Math.round(maxCreditsLimit)  + '.', {
        timeout: 0,
        position: SnotifyPosition.centerCenter,
        closeOnClick: false,
        buttons: [
          {text: 'Ok'}
        ]
      });
      return;
    }

    this.quotationDetail.quotationsModules = [];

    let qModules: Array<QuotationModule> = []
    this.coreModules.forEach(function(m) {
      if(m.modSubChecked) {
        qModules.push({modChecked: m.modChecked, modSubChecked: m.modSubChecked, rulesKey: m.rulesKey, sequence: m.sequence, 
          connector: m.connector, moduleCode: m.moduleCode, moduleName: m.moduleName, moduleCost: m.moduleCost, moduleCredits: m.moduleCredits, 
           electiveGroup1: m.electiveGroup1, electiveGroup2: m.electiveGroup2, compulsorySubGroup: m.compulsorySubGroup, isCore: true, isDisabled: m.isDisabled, isSubDisabled: m.isSubDisabled});
      }
    });

    this.electiveModules.forEach(function(m) {
      if(m.modSubChecked) {
        qModules.push({modChecked: m.modChecked, modSubChecked: m.modSubChecked, rulesKey: m.rulesKey, sequence: m.sequence, 
          connector: m.connector, moduleCode: m.moduleCode, moduleName: m.moduleName, moduleCost: m.moduleCost,moduleCredits: m.moduleCredits, 
           electiveGroup1: m.electiveGroup1, electiveGroup2: m.electiveGroup2, compulsorySubGroup: m.compulsorySubGroup, isCore: false, isDisabled: m.isDisabled, isSubDisabled: m.isSubDisabled});
      }
    });

    this.quotationDetail.quotationsModules = qModules;
    this.globals.quotationDetail = this.quotationDetail;
    this.router.navigate(['/default', {outlets: {'main': ['summary']}}]);
  }

  showError(source: string){
    this.notifier.error('An error occurred at ' + source + '. Please try again and if the problem persists, please contact support at servicedesk@uwc.ac.za', {
      timeout: 0,
      position: SnotifyPosition.centerCenter,
      closeOnClick: false,
      buttons: [
        {text: 'Ok'}
      ]
    });
  }
}

interface SubTotalItem {
  description: string;
  amount: number;
  credits: number;

}

interface PrevSelectedElectGroups {
  electGroup1: number;
  electGroup2: number;
}

interface GroupsToDisable {
  electGroup1: number;
  electGroup2: number;
}
